// src/app/store.js
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./slice/authSlice";
import galleryReducer from "./slice/gallerySlice";
import invoiceReducer from "./slice/invoiceSlice";
import quotationReducer from "./slice/quotationSlice";
import blogReducer from "./slice/blogSlice";
import privateAlbumReducer from "./slice/privateAlbumSlice";
import publicGalleryReducer from "./slice/publicGallerySlice";
import uiReducer from "./slice/uiSlice";
import eventReducer from "./slice/eventSlice";
import invitationReducer from "./slice/invitationSlice";
import crmReducer from "./slice/crmSlice"; // Import the CRM reducer
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "gallery", "privateAlbum"],
};

const rootReducer = combineReducers({
  auth: authReducer,
  gallery: galleryReducer,
  invoices: invoiceReducer,
  quotations: quotationReducer,
  blog: blogReducer,
  privateAlbum: privateAlbumReducer,
  publicGallery: publicGalleryReducer,
  invitations: invitationReducer,
  ui: uiReducer,
  events: eventReducer,
  crm: crmReducer, // Add the CRM reducer here
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

export const persistor = persistStore(store);
